import { funk } from '@theme-ui/presets'
import { GatsbyBrowser } from 'gatsby'
import React from 'react'
import { ThemeProvider } from 'theme-ui'

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => <ThemeProvider theme={funk}>{element}</ThemeProvider>
